import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { clearAuthTokens, clearUkekFromStorage } from '@/utils/sessionStorage';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const logoutThunk = createAppAsyncThunk<void>(
  'auth/logout',
  async(_, { extra: { authService, pocServices }, getState }) => {
    const userId = getState().auth.userId ?? getState().user.user?.id ?? null;

    try {
      await pocServices.p2pStackManagerService.shutdownAllStacks();
    } catch {
      // Best-effort cleanup only
    }

    if (userId !== null) {
      clearUkekFromStorage(userId);
    }

    await authService.logout();
    clearAuthTokens();
  }
);
